import React from "react";
import PropTypes from "prop-types";
import style from "../../stylesheets/StoreFilterContainer.module.scss";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";

const MobileFilterContainer = ({
  toggleMobileFilter,
  mobileFilterOpened,
  nbHits,
  facetFiltersElems,
  loadFiltersAndResults,
  priceFilter,
}) => {
  const handleToggleMobileFilter = (e, applyFilters) => {
    toggleMobileFilter(applyFilters);
  };

  const handleClearAll = () => {
    loadFiltersAndResults({ params: {}, loadFiltersOnlyForMobile: true });
  };

  return mobileFilterOpened ? (
    <div className={mobileStyle.openFilter}>
      <div className={mobileStyle.topContainer}>
        <div className={mobileStyle.filterImgContainer}>
          <img
            className={mobileStyle.filterImg}
            src="https://cdn-s3.touchofmodern.com/images/icons/icon_filter%402x.png"
            alt="filter"
          />
          <div>Filters</div>
        </div>
        <img
          className={mobileStyle.cancel}
          onClick={handleToggleMobileFilter}
          src="https://cdn-s3.touchofmodern.com/images/icons/icon_filterClose%402x.png"
          alt="filterClose"
          tabIndex="0"
        />
      </div>
      <div className={mobileStyle.filtersContainer}>
        {priceFilter}
        {facetFiltersElems}
      </div>
      <div className={mobileStyle.navigation}>
        <div>{nbHits} results</div>
        <div className={mobileStyle.doneContainer}>
          <div
            className={style.clearAllFilter}
            onClick={handleClearAll}
            tabIndex="0"
          >
            Clear all
          </div>
          <button
            className={`${mobileStyle.done} btn btn-primary`}
            onClick={(e) => handleToggleMobileFilter(e, true)}
            tabIndex="0"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={mobileStyle.closedFilter}
      onClick={handleToggleMobileFilter}
      tabIndex="0"
    >
      <div className={mobileStyle.filterImgContainer}>
        <img
          className={mobileStyle.filterImg}
          src="https://cdn-s3.touchofmodern.com/images/icons/icon_filter%402x.png"
          alt="filter"
        />
        <div>Filters</div>
      </div>
      <img
        className={mobileStyle.filterExpandImg}
        src="https://cdn-s3.touchofmodern.com/images/icons/icon_filterExpand%402x.png"
        alt="expand"
      />
    </div>
  );
};

MobileFilterContainer.propTypes = {
  toggleMobileFilter: PropTypes.func.isRequired,
  mobileFilterOpened: PropTypes.bool.isRequired,
  loadFiltersAndResults: PropTypes.func.isRequired,
};

export default MobileFilterContainer;
